import React from 'react';
import { TextFieldProps } from '@mui/material/TextField';

import { FormInput, IProps as IFormInput } from './FormInput';

interface IFormTextareaProps extends IFormInput {
  maxLength?: number;
}

export const FormTextarea: React.FC<TextFieldProps & IFormTextareaProps> = ({
  maxLength,
  value,
  ...props
}) => {
  const helpText = maxLength
    ? `${Math.max(0, maxLength - `${value}`.length)} Characters Remaining`
    : props.helpText;

  return (
    <FormInput
      inputProps={{ maxLength }}
      value={value}
      helpText={helpText}
      {...props}
      multiline={true}
    />
  );
};
